import axios, { AxiosResponse } from "axios";
import { IRecord, ISearchResult } from "../models/isearch-response";
import { TrackingDetailModel } from "../models/tracking-detail-model";
import { handleAddToShoppingListClick } from "../../shoppingList/shopping-list";

const resultContainer: HTMLElement = document.querySelector(".result__body");
const resultProtoType: HTMLElement = document.querySelector(".prototype__resultitem");
const searchResult: HTMLElement = document.querySelector("#searchResult");

function convertKeysToCamelCase(obj: any): any {
	if (Array.isArray(obj)) {
		return obj.map(convertKeysToCamelCase);
	} else if (obj !== null && typeof obj === "object") {
		const newObj: any = {};
		for (const key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				newObj[toCamelCase(key)] = convertKeysToCamelCase(obj[key]);
			}
		}
		return newObj;
	}
	return obj;
}

function toCamelCase(str: string) {
	return str.charAt(0).toLowerCase() + str.slice(1);
}

declare const emos3: any;

export const EcondaTrackingSearchResult = (): void => {
	if (typeof emos3 !== "undefined" && searchResult.getAttribute("data-query")) {
		emos3.send({
			search: [searchResult.getAttribute("data-query"), searchResult.getAttribute("data-resultcount")]
		});
	}
};

export const UpdateResults = (records: IRecord[]): void => {
	resultContainer.innerHTML = "";
	const rawJson = JSON.parse(document.querySelector("[data-searchresult]")?.getAttribute("data-searchresult") || "{}");
	const searchResultJson = convertKeysToCamelCase(rawJson) as ISearchResult;

	records.forEach(function(record) {
		try {
			const resultItem = resultProtoType.cloneNode(true) as HTMLElement;
			resultItem.classList.remove("prototype__resultitem");

			UpdateLabels(record, resultItem);
			UpdateSeminarType(resultItem, record);
			UpdateTitle(resultItem, record, searchResultJson);
			UpdateSubtitle(resultItem, record);
			UpdatePlaces(resultItem, record);
			UpdateDates(resultItem, record);
			UpdateFao(resultItem, record);
			UpdateLinkToDetailPage(resultItem, record, searchResultJson);
			UpdateShoppingListButton(resultItem, record);

			resultContainer.append(resultItem);
		} catch (error) {
			console.error(error);
		}
	});
};

function UpdateLinkToDetailPage(resultItem: HTMLElement, record: IRecord, records: ISearchResult): void {
	const productLink = resultItem.querySelector(".button__result") as HTMLAnchorElement;
	productLink.href = record.recordItem.produktUrl;
	productLink.setAttribute("data-productid", record.id);
	productLink.setAttribute("data-query", searchResult.getAttribute("data-query"));
	productLink.setAttribute("data-position", record.position.toString());
	productLink.setAttribute("data-origposition", record.recordItem.originPosition);
	productLink.setAttribute("data-page", records.paging.currentPage.toString());
	productLink.setAttribute("data-pagesize", records.paging.resultsPerPage.toString());
	productLink.setAttribute("data-origpagesize", records.paging.resultsPerPage.toString());
	productLink.setAttribute("data-factfindercampaign", record.recordItem.ffCampaign);
}

function UpdateFao(resultItem: HTMLElement, record: IRecord): void {
	resultItem.querySelector(".event__txt__fao").innerHTML = record.recordItem.alleFaoCredits;
}

function UpdateDates(resultItem: HTMLElement, record: IRecord): void {
	resultItem.querySelector(".event__txt__dates").innerHTML = `${record.recordItem.engagementDateClear} ${
		record.recordItem.otherEngagementsExist ? "<br> (weitere Termine verfügbar)" : ""
	}`;
}

function UpdatePlaces(resultItem: HTMLElement, record: IRecord): void {
	const cities = record.recordItem.cities;
	resultItem.querySelector(".event__txt__places").innerHTML = `${cities[0]} ${
		cities.length > 1 ? `+ ${cities.length - 1} ${cities.length - 1 > 1 ? "weitere Orte" : "weiterer Ort"}` : ""
	}`;
}

function UpdateSubtitle(resultItem: HTMLElement, record: IRecord): void {
	const subTitleLink = resultItem.querySelector(".event__title--sub") as HTMLAnchorElement;
	if (!record.recordItem.untertitel) {
		subTitleLink.remove();
	} else {
		subTitleLink.innerHTML = record.recordItem.untertitel;
	}
}

function UpdateTitle(resultItem: HTMLElement, record: IRecord, records: ISearchResult): void {
	const titleLink = resultItem.querySelector(".event__title .event__link") as HTMLAnchorElement;
	titleLink.innerHTML = record.recordItem.titel;
	titleLink.href = record.recordItem.produktUrl;
	titleLink.setAttribute("data-productid", record.id);
	titleLink.setAttribute("data-query", searchResult.getAttribute("data-query"));
	titleLink.setAttribute("data-position", record.position.toString());
	titleLink.setAttribute("data-origposition", record.recordItem.originPosition);
	titleLink.setAttribute("data-page", records.paging.currentPage.toString());
	titleLink.setAttribute("data-pagesize", records.paging.resultsPerPage.toString());
	titleLink.setAttribute("data-origpagesize", records.paging.resultsPerPage.toString());
	titleLink.setAttribute("data-factfindercampaign", record.recordItem.ffCampaign);
}

function UpdateSeminarType(resultItem: HTMLElement, record: IRecord): void {
	resultItem.querySelector(".event__type").innerHTML = record.recordItem.seminartyp;
}

function UpdateLabels(record: IRecord, resultItem: HTMLElement): void {
	if (record.recordItem.isNew !== "true") {
		resultItem.querySelector(".event__label__new").remove();
	}
	if (record.recordItem.isTopArticle !== "true") {
		resultItem.querySelector(".event__label__top").remove();
	}
}

function TrackingSearchFunction(this: HTMLElement) {
	const data = {
		ProductID: this.getAttribute("data-productid"),
		Query: this.getAttribute("data-query"),
		Position: this.getAttribute("data-position"),
		OrigPosition: this.getAttribute("data-origposition"),
		Page: this.getAttribute("data-page"),
		PageSize: this.getAttribute("data-pagesize"),
		OrigPageSize: this.getAttribute("data-origpagesize"),
		FactFinderCampaign: this.getAttribute("data-factfindercampaign")
	};
	axios
		.post<TrackingDetailModel>(`/umbraco/api/FactFinderTracking/SearchTracking`, data)
		.then((result: AxiosResponse) => {})
		.catch((error: any) => {
			if (error?.response?.data) {
				console.log(error?.response?.data);
			}
		});
}
function UpdateShoppingListButton(resultItem: HTMLElement, record: IRecord) {
	const shoppingListButton = resultItem.querySelector(".shoppinglistAdd") as HTMLButtonElement;
	shoppingListButton.setAttribute("data-productid", record.recordItem.productId);
	shoppingListButton.addEventListener("click", () => handleAddToShoppingListClick(shoppingListButton));
}
